module.exports = __webpack_public_path__ + "img/end_icon.905c5a21.png";